var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("wrapper-note " + _vm.type + " " + _vm.customClass)},[_c('span',[(_vm.isFailedOrNormal)?_c('icon-warning-circle'):_c('icon-check-circle',{attrs:{"fill":"#006644"}})],1),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }